export class CodeListInfoDto {
    codeListId: number
    codeListQuantity: number;
    constructor(codeListId: number,codeListQuantity: number){
        this.codeListId = codeListId; 
        this.codeListQuantity = codeListQuantity; 

    }
  
}